// Null - Empty Check
export const validateNotNull = (field, value) => {
    if ( (!value) || (value.trim() === '') || (value === undefined) ) {
        field = field.charAt(0).toUpperCase() + field.slice(1);
        return `${field} Can Not Be Empty`;
    }
    return '';
}

// Admin-Users
export const validateFirstName = (firstName) => {
    let err = [];

    if (!firstName) { err.push('First Name is required'); }
    if (firstName.trim().length < 2) { err.push('First Name must be at least 2 characters'); }
    if (firstName.trim().length > 50 ) { err.push('First Name must be less than 50 characters'); }
    if (/(?=.*[@#^$!%*?&()])/.test(firstName)) { err.push('First Name must not contain special characters'); }

    if (err.length > 0) {
        return err;
    } else {
        return "";
    }
}

export const validateLastName = (lastName) => {
    let err = [];

    if (!lastName) { err.push('Last Name is required.'); }
    if (lastName.trim().length < 2) { err.push('Last Name must be at least 2 characters.'); }
    if (lastName.trim().length > 50 ) { err.push('Last Name must be less than 50 characters'); }
    if (/(?=.*[@#^$!%*?&()])/.test(lastName)) { err.push('Last Name must not contain special characters'); }

    if (err.length > 0) {
        return err;
    } else {
        return "";
    }
}

export const validateUserName = (userName) => {
    if (!userName) return 'User Name is required.';
    if (userName.trim().length < 2) return 'User Name must be at least 2 characters.';
    if (userName.trim().length > 25) return 'User Name must be less than 25 characters.';

    return '';
    
}

export const validatePhoneNumber = (phone) => {
    if(!phone) return 'Phone Number is required.';
    if(!/^\(?\d{3}\)?[\s-]\d{3}[\s-]\d{4}$/.test(phone))
    return 'Invalid phone number format, e.g., 123-456-7890';
    return'';
}

export const validateEmailAddr = (email) => {
    if (!email) return 'Email is required.';
    if (!/\S+@\S+\.\S+/.test(email)) return 'Invalid email format.';
    
    return '';
    
}

export const validateCurrentPassword = (currentPassword) => {
    if (currentPassword.trim() === '') return 'Current Password Can Not Be Empty';
    return '';
}

export const validatePassword = (password) => {
    let err = [];

    if (password.trim() === '') { err.push('Password Can Not Be Empty'); }
    if (password.trim().length < 15) { err.push('Password Must Be 15 Characters Or Greater' ); }
    if (!/(?=.*[a-z])/.test(password)) { err.push('Password must contain at least one lowercase letter'); }
    if (!/(?=.*[A-Z])/.test(password)) { err.push('Password must contain at least one uppercase letter'); }
    if (!/(?=.*\d)/.test(password)) { err.push('Password must contain at least one number'); }
    if (!/(?=.*[@$!%*?&])/.test(password)) { err.push('Password must contain at least one special character (@$!%*?&)'); }
    
    if (err.length > 0) {
        return err;
    } else {
        return "";
    }
}

export const validateConfirmPassword = (password, confirmPassword) => {
    let err = [];

    if (confirmPassword.trim() === '') { err.push('Password Can Not Be Empty'); }
    if (password !== confirmPassword) { err.push('Password Does Not Match'); }

    if (err.length > 0) {
        return err;
    } else {
        return "";
    }
}

// Admin-Settings
export const validateCategory = (category) => {
    if (!category) return 'Category is required.';
    if (category.trim() === '') return 'Category Can Not Be Empty';
    return '';
}

export const validateParameter = (parameter) => {
    if (!parameter) return 'Parameter is required.';
    if (parameter.trim() === '') return 'Parameter Can Not Be Empty';
    return '';
}

export const validateSetting = (setting) => {
    if (!setting) return 'Setting is required.';
    if (setting.trim() === '') return 'Setting Can Not Be Empty';
    return '';
}
